import React from "react";
import RequestItemList from "./requestItemList/RequestItemList";

const RequestItem = () => {
  return <RequestItemList />;
};

export default RequestItem;
